<template>
  <div
    class="image-dropzone"
    :class="{ 'image-dropzone--dragover': dragOver }"
    @dragover="handleDragEvents"
    @dragleave="handleDragEvents"
    @dragenter="handleDragEvents"
    @drop="handleDragEvents"
  >
    <!-- Visible content area, fully interactive -->
    <div class="image-dropzone__content">
      <div class="image-dropzone__placeholder">Drop file here!</div>
      <slot />
    </div>

    <!-- Hidden input (no label association) -->
    <input
      ref="fileInput"
      type="file"
      :accept="acceptedFormats"
      :multiple="multiple"
      :disabled="disabled"
      class="image-dropzone__input-hidden"
      @change="handleChange"
      tabindex="-1"
    />
  </div>
</template>

<script>
export default {
  name: 'ImageDropzone',
  props: {
    acceptedFormats: {
      type: String,
      default: 'image/*,video/*',
    },
    multiple: Boolean,
    disabled: Boolean,
  },
  data() {
    return {
      dragOver: false,
      dragCounter: 0,
    };
  },
  methods: {
    openPicker() {
      this.$refs.fileInput?.click();
      this.$emit('inputClick');
    },

    handleChange(e) {
      if (this.disabled) return;

      const files = Array.from(e.target.files || []);
      if (files.length) {
        this.$emit('fileDropped', this.multiple ? files : files[0]);
      }
    },

    handleDragEvents(e) {
      e.preventDefault();

      if (this.disabled) return;

      if (e.type === 'drop') {
        this.dragOver = false;
        this.dragCounter = 0;
        const files = Array.from(e.dataTransfer?.files || []);
        if (files.length) {
          this.$emit('fileDropped', this.multiple ? files : files[0]);
        }
        return;
      }

      const isFileDrop =
        e.dataTransfer &&
        Array.from(e.dataTransfer.types || []).includes('Files');
      if (!isFileDrop) return;

      if (e.type === 'dragenter') {
        this.dragCounter++;
        this.dragOver = true;
      } else if (e.type === 'dragleave') {
        this.dragCounter--;
        if (this.dragCounter <= 0) {
          this.dragOver = false;
          this.dragCounter = 0;
        }
      } else if (e.type === 'dragover') {
        e.dataTransfer.dropEffect = 'copy';
      }
    },
  },
};
</script>

<style lang="less">
.image-dropzone {
  position: relative;

  &__content {
    position: relative;
    height: 100%;
  }

  &__input-hidden {
    position: absolute !important;
    width: 0;
    height: 0;
    opacity: 0;
    pointer-events: none;
  }

  &__placeholder {
    opacity: 0;
    display: none;
  }

  &--dragover {
    .image-dropzone__placeholder {
      height: 100%;
      width: 100%;
      position: absolute;
      opacity: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(0, 0, 0, 0.65);
      color: #fff;
      font-size: 20px;
      font-weight: bold;
      z-index: 10;
    }
  }
}
</style>
